import React, { Component } from "react";
import helpers from '../../helpers';

import '../../plugins/swipebook-pdf-viewer/css/flipbook.style.css';
require('../../plugins/swipebook-pdf-viewer/js/flipbook.js');

class Menu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            app: props.app,
            pdfUrl: '',
            pdf: '',
        };
    }

    remove = async () => {
        await helpers.removeFileFromUser({userRef: this.state.app.state.userRef, file: this.state.pdf});
        helpers.closeMenu();
    }

    async setPdf(key) {
        $("#menu-file .file").html('');
        console.log(key);
        const pdfUrl = await helpers.serviceRequest('downloadPdf', { key: `documents/${key}.pdf` });
        console.log(pdfUrl.presigned_url);
        if(pdfUrl) {
            const pdf = helpers.getPathFromUrl(pdfUrl.presigned_url);
            this.setState({
                pdfUrl, 
                pdf
            })
            $("#menu-file .file").swipeBook({
                hideMenu: true,
                backgroundColor: '#ccc',
                pdfUrl: pdfUrl.presigned_url,
            });
        }
    }

    // calc(70vh - 105px)

    render() {
        return (
            <div id="menu-file" className="menu menu-box-bottom" data-menu-height="315" data-menu-effect="menu-over">
                <div className="center-text">
                    <div>
                        <a href="#" className="file-delete ripple" onClick={() => this.remove()}><i className="fad fa-trash"></i><span>Delete</span></a>
                        <div className="file"></div>
                    </div>
                </div>
                <a href="#" className="close-menu button button-s button-center-large button-round-medium shadow-large bg-highlight">close</a>
            </div>
        )
    }
}

export default Menu;


// WEBPACK FOOTER //
// ./src/components/menus/file.js